import React from "react";
import "../css/HelpPage.css";
import GettingStartedIcon from "../assets/icons/getting-started.png";
import MyAccountIcon from "../assets/icons/my-account.png";
import DataPrivacyIcon from "../assets/icons/data&privacy.png";
import TermsServicesIcon from "../assets/icons/terms&services.png";
import SubscriptionBillingIcon from "../assets/icons/subscription&billing.png";
import FAQIcon from "../assets/icons/FAQ.png";

const HelpPage = () => {
  const helpCards = [
    {
      title: "Getting Started",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      icon: GettingStartedIcon,
      link: "#",
    },
    {
      title: "My Account",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      icon: MyAccountIcon,
      link: "#",
    },
    {
      title: "Data & Privacy",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      icon: DataPrivacyIcon,
      link: "#",
    },
    {
      title: "Terms of Services",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      icon: TermsServicesIcon,
      link: "#",
    },
    {
      title: "Subscription Billing",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      icon: SubscriptionBillingIcon,
      link: "#",
    },
    {
      title: "FAQ",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      icon: FAQIcon,
      link: "#",
    },
  ];

  return (
    <div className="help-container">
      <h1 className="help-title">Need Help ?</h1>
      <p className="help-subtitle">
        Here are all the support resources we offer. Or Search out and get the
        help you need.
      </p>

      {/* Search Bar with Icon */}
      <div className="search-box custom-search-group">
        <span className="search-icon"> <i className="bi bi-search"></i></span>
        <input type="text" placeholder="Ask a Question" />
      </div>

      {/* Help Cards */}
      <div className="help-grid">
        {helpCards.map((card, index) => (
          <div className="help-card" key={index}>
            <div className="help-icon">
              <img className="icon-image" src={card.icon} alt={card.title} />
            </div>
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
            <a href={card.link} className="learn-link">
              Learn More
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpPage;
